import React, { Component } from "react";
import { injectIntl } from "react-intl";
import CommonUploadAsync from "../asyncUpload";
import CustomUpload from "./customUpload";

const UPLOAD_PROPS = { accept: "image/*,.pdf, .doc,.docx,.xml,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document" };

class UploadAttachments extends Component{
    constructor(props){
	super(props);
	this.state={
	};
    }

    
    onProgress = ({ percent }) => {
	this.setState({ progress: parseInt(percent) });
    };

    handleUpload = (data) => {
	const {uploadHandler, fieldType} = this.props;
	uploadHandler(data, fieldType);
	this.setState({data});
    };

    deleteSelectedFile = () => {
	const {deleteUpload, fieldType} = this.props;
	deleteUpload(fieldType);
	this.setState({data:""});
    }
    

    showFileName = () => {
	const {data} = this.state;
	console.log("data upload === >>>", data);
	const {files={}, type="", openShowDocsModal}  = this.props;
	let fileNameUi;
	let count = 0;
	if(data){
	    fileNameUi = data.map((file, index) =>{
		const imgFilesDetails = [];
		const pdfFilesDetails = [];
		
		const {originalname="", file_path=""} = file;
		const file_name_arr = originalname.split(".");
		const extension = file_name_arr[file_name_arr.length-1];
		if(extension==="png" || extension==="jpg" || extension === "jpeg"){
		    imgFilesDetails.push({originalname, original:file_path});
		}
		else if(extension==="pdf"){
		    pdfFilesDetails.push({originalname, file_path});
		}
		
		
		
		return(
			<div key={index} className="w80 ml20 mr20">
			{type==="async"?<span className="medium fontsize16 word-wrap  underline clickable" onClick={()=>openShowDocsModal({images:imgFilesDetails, pdfs:pdfFilesDetails})}>{file.originalname}</span>
			 :
			 <span className="fontsize16 medium  word-wrap" >{file.name}</span>}
			</div>
		);
	    });
	}
	else{
	    fileNameUi = [];
	    if(files.length){
		for(const file of files){
		    const imgFilesDetails = [];
		    const pdfFilesDetails = [];
		    const {file_name="", file_path=""} = file;
		    const file_name_arr = file_name.split(".");
		    const extension = file_name_arr[file_name_arr.length-1];
		    if(extension==="png" || extension==="jpg" || extension === "jpeg"){
			imgFilesDetails.push({originalname:file_name, original:file_path});
		    }
		    else if(extension==="pdf"){
			pdfFilesDetails.push({originalname:file_name, file_path});
		    }
		    fileNameUi.push(
			    <div key={count} className="w80 ml20 mr20">
			    {(imgFilesDetails || pdfFilesDetails)?<span className="medium fontsize16 word-wrap  underline clickable" onClick={()=>openShowDocsModal({images:imgFilesDetails, pdfs:pdfFilesDetails})}>{file.file_name}</span>
			 :
			     <span className="fontsize16 medium  word-wrap" >{file.file_name}</span>}
			    </div>
		    );
		    count+=1;
		}
	    }
	    else if(Object.keys(files).includes("file_name")){

		const imgFilesDetails = [];
		const pdfFilesDetails = [];
		
		const {file_name="", file_path=""} = files;
		const file_name_arr = file_name.split(".");
		const extension = file_name_arr[file_name_arr.length-1];
		if(extension==="png" || extension==="jpg" || extension === "jpeg"){
		    imgFilesDetails.push({originalname:file_name, original:file_path});
		}
		else if(extension==="pdf"){
		    pdfFilesDetails.push({originalname:file_name, file_path});
		}
		
		
		
		fileNameUi.push(
			<div key={count} className="w80 ml20 mr20">
			{(imgFilesDetails || pdfFilesDetails)?<span className="medium fontsize16 word-wrap  underline clickable" onClick={()=>openShowDocsModal({images:imgFilesDetails, pdfs:pdfFilesDetails})}>{files.file_name}</span>
			 :
			 <span className="fontsize16 medium  word-wrap" >{files.file_name}</span>}
			</div>
		);
		
	    }
	    else{
		for(const file in files){
		    
		    const fileObj = files[file];
		    const imgFilesDetails = [];
		    const pdfFilesDetails = [];
		    const {file_name="", file_path=""} = fileObj;
		    const file_name_arr = file_name.split(".");
		    const extension = file_name_arr[file_name_arr.length-1];
		    if(extension==="png" || extension==="jpg" || extension === "jpeg"){
			imgFilesDetails.push({originalname:file_name, original:file_path});
		    }
		    else if(extension==="pdf"){
			pdfFilesDetails.push({originalname:file_name, file_path});
		    }
		    
		    
		    fileNameUi.push(
			    <div key={count} className="w80 ml20 mr20">
			    {(imgFilesDetails || pdfFilesDetails)?<span className="medium fontsize16 word-wrap  underline clickable" onClick={()=>openShowDocsModal({images:imgFilesDetails, pdfs:pdfFilesDetails})}>{fileObj.file_name}</span>
			     :
			     <span className="fontsize16 medium  word-wrap" >{fileObj.file_name}</span>}
			    </div>
		    );
		    count+=1;
		}
	    }
	    
	}
	return (
		<div className="mt20">
		{fileNameUi}
		</div>
	);
    }
    
    render(){

	const {handleUpload, showFileName} = this;
	const {data} = this.state;
	const { width, multiple=false, placeHolder, files={}, type=""} = this.props;

	let minHeight;
	if(multiple){
	    minHeight="150px";
	}
	else{
	    minHeight = "45px";
	}

	const uploadProps = {...UPLOAD_PROPS, multiple:multiple};
	
	return(
		<div className={`upload-border ${width} mt20`} style={{minHeight:minHeight}}>
		
		<CommonUploadAsync
	    uploadProps={uploadProps}
	    handleComplete={handleUpload}
	    component={<CustomUpload fieldName={placeHolder}/>}
		/>
		{(data || files)?
		 showFileName()
		 :null}
	    </div>
	);
    }
}


export default injectIntl(UploadAttachments);
